import React, { useId } from 'react';
import { MultiValueGenericProps, components } from 'react-select';
import Tooltip from 'components/controls/Tooltip';

/**
 * If multi value chip gets too long, we will show a tooltip on hover.
 */
const MultiValueLabelWithTooltip: React.FC<MultiValueGenericProps> = (props) => {
  const id = useId();
  return (
    <>
      <Tooltip position="titleEllipsed" targetId={id}>
        {props.children}
      </Tooltip>
      <components.MultiValueLabel
        {...props}
        innerProps={{ ...props.innerProps, id } as any /* This works but typescript is upset */}
      />
    </>
  );
};

export default MultiValueLabelWithTooltip;
